
<div class="approvals-search-calander-container" >

    <div class="approvals-search-bar">
        <div class="approvals-search-content">
            <input class="approvals-search-text" placeholder="Search..." type="text" [(ngModel)]="searchValue" (ngModelChange)="searchOrders()">
            <img src="../../../../../assets/order-to-cash-icons/search.svg" alt="Search Icon" class="approvals-search-icon">
        </div>
    </div>

<div class="search-datepicker-spacer"></div>

    <div class="approvals-spacer-reset-container">
        <button *ngIf="isFilterBtnVisible" mat-button="outlined" class="reset-filter-btn" (click)="resetApprovalList()">Clear Filters</button>
    </div>

    <button class="filtering-btn" mat-flat-button type="button" (click)="openFilterDialog()">
        <div class="filtering-content">
            <img src="../../../../../assets/order-to-cash-icons/tune-filter.svg" alt="Filter Icon" class="filtering-icon">
            <span><p class="filtering-text">Filtering</p></span>
        </div>
    </button>
</div>

<div class="approvals-container">

    <div *ngIf="isNoItemsFound" class="no-items-message-container">
        <div class="no-items-message">Sorry! No items that need approval. Or no items found within the selected date range.</div>
    </div>

    <mat-card class="approvals-item-card" *ngFor="let approvalItem of paginatedArray" [value]="approvalItem">

        <div class="icon-and-text-container">

            <div class="approval-text-scale">

                <div class="approval-inner-text-container">
                    <p class="approval-text">Agent Name: <span class="approval-val-text text-overflow-limited-large">{{approvalItem.repName}}</span></p>
                </div>

                <div class="splitter"> | </div>

                <div class="approval-inner-text-container">
                    <p class="approval-text">Order Id: <span class="approval-val-text text-overflow-limited-medium">{{approvalItem.displayOrderNumber ?? approvalItem.orderNumber}}</span></p>
                </div>

                <div class="splitter"> | </div>

                <div class="approval-inner-text-container">
                    <p class="approval-text">Order date:  <span class="approval-val-text">{{approvalItem.orderDate ? dayjs(approvalItem.orderDate).format(dateStringFormatting) : placeholder}}</span></p>
                </div>

                <div class="splitter"> | </div>

                <div class="approval-inner-text-container">
                    <p class="approval-text">Client: <span class="approval-val-text text-overflow-limited-large">{{approvalItem.clientName}}</span></p>
                </div>

                <div class="splitter"> | </div>

                <div class="approval-inner-text-container">
                    <p class="approval-text">Order Value: <span class="approval-val-text text-overflow-limited-small">{{approvalItem.totalPrice | currency:'R':'symbol':'1.0-2'}}</span></p>
                </div>

                <div class="splitter"> | </div>

                <div class="approval-inner-text-container">
                    <p class="approval-text">Max Discount:  <span class="approval-val-text">{{approvalItem.maxDiscount}}%</span></p>
                </div>


            </div>



        </div>


        <div class="approvals-button-container" *ngIf="!isSmallBtnVisible">
            <button class="approve-btn approvals-lg-btn" mat-flat-button type="button" (click)="openApproveConfirmDialog(approvalItem.id)">
                <div class="approve-btn-content">
                    <span><p class="approve-btn-text">Approve</p></span>
                </div>
            </button>

            <button class="reject-btn approvals-lg-btn" mat-flat-button type="button" (click)="openRejectConfirmDialog(approvalItem.id)">
                <div class="reject-btn-content">
                    <span><p class="reject-btn-text">Reject</p></span>
                </div>
            </button>

            <button class="review-btn approvals-lg-btn" mat-flat-button type="button" (click)="reviewApproval(approvalItem.id)">
                <div class="review-btn-content">
                    <span><p class="review-btn-text">Review</p></span>
                </div>
            </button>
        </div>

        <div class="approvals-button-container-sm" *ngIf="isSmallBtnVisible">
            <button class="approvals-sm-btn approve-btn" mat-flat-button type="button" (click)="openApproveConfirmDialog(approvalItem.id)">
                <div class="approvals-sm-icon-container">
                    <img src="../../../../../assets/order-to-cash-icons/check-base.svg" alt="Attach Icon" class="approval-icons-sm-screen">
                </div>
            </button>

            <button class="approvals-sm-btn reject-btn" mat-flat-button type="button" (click)="openRejectConfirmDialog(approvalItem.id)">
                <div class="approvals-sm-icon-container">
                    <img src="../../../../../assets/order-to-cash-icons/close-base.svg" alt="Attach Icon" class="approval-icons-sm-screen">
                </div>
            </button>

            <button class="approvals-sm-btn review-btn" mat-flat-button type="button" (click)="reviewApproval(approvalItem.id)">
                <div class="approvals-sm-icon-container">
                    <img src="../../../../../assets/order-to-cash-icons/otc-view-eye.svg" alt="Attach Icon" class="approval-icons-sm-screen">
                </div>
            </button>
        </div>

    </mat-card>
</div>
    <div class="paginator-container-approvals">
        <mat-paginator
                (page)="onPaginateChange($event)"
                [pageSize]="pageSize"
                [pageIndex]="currentPage"
                [pageSizeOptions]="[5, 10, 20]"
                [showFirstLastButtons] = "true"
                [length]="totalElements"
        >
        </mat-paginator>
    </div>



